module.exports = "/images/coins.svg?a770833482b739e4251f78baef49716b";